<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
    
    <div class="page_header_wrap">
    <div class="page_header">
          <div>
            <h2 >Documentation Details</h2>
          </div>
          </div>
    </div>        

        <div class="knowledge_base_wrap">
         

           
          <div class="knowledge_base_cnt knowledge_base_details">
            <div class="knowledge_base_list">
              <ul>
                <li v-if="checkValue(knowledgeDetails  , 'title' )">
                  <label>Title</label> <p> 
                     {{checkValue(knowledgeDetails  , 'title' )}}
                   
                    </p>
                </li>
                <li v-if="checkValue(knowledgeDetails  , 'description' )">
                    <label>Description</label> <p>
                       {{checkValue(knowledgeDetails  , 'description' )}}
                       </p>
                </li>
                <!-- <li v-if="checkValue(knowledgeDetails  , 'bug' )">
                  <label>Bug</label> <p>
                    {{checkValue(knowledgeDetails  , 'bug' )}}
                    
                      </p>
                </li>
                <li v-if="checkValue(knowledgeDetails  , 'deviceFamDetails' ,'name')">
                  <label>Device Family</label> <p> 
                    {{checkValue(knowledgeDetails  , 'deviceFamDetails' ,'name')}}
                     </p>
                </li>
                <li v-if="checkValue(knowledgeDetails  , 'typeDetails' ,'name')!=''">
                  <label>Type Details</label> <p>
                     {{checkValue(knowledgeDetails  , 'typeDetails' ,'name')}}
                      </p>
                </li>
                <li v-if="checkValue(knowledgeDetails  , 'versionDetails' ,'name' ) !=''">
                <label>Version Details</label> <p>
                  {{checkValue(knowledgeDetails  , 'versionDetails' ,'name' )}}
                   
                   </p>
                </li>
                <li v-if="checkValue(knowledgeDetails  , 'fixVersionDetails' ,'name' ) !=''">
                <label>Fixed Version Details</label> <p>
                   {{checkValue(knowledgeDetails  , 'fixVersionDetails' ,'name' )}}
                  
                   </p>
                </li> -->
                 <li>
                <label>Documents</label> 
                <p v-if="knowledgeDetails.documents && knowledgeDetails.documents.length > 0">
                   {{knowledgeDetails.documents[0].name}}
                   <span @click="download_file(knowledgeDetails.documents[0])" class="material-icons download">get_app</span>
                   </p>
                    
                </li>
                <!-- <li v-if="checkValue(knowledgeDetails  , 'wrkAround' ) !=''">
                <label>Work Around</label> <p>
                   {{checkValue(knowledgeDetails  , 'wrkAround' )}}
                   </p>
                </li> -->
              </ul> 
            </div>
             
          </div>
        </div>    
          
    </div>
</template>

<script>
 import vSelect from 'vue-select'
 import _ from "lodash";
export default{
  components: { 
    vSelect,
 
  },
  data () {
    return {
       textarea: '',
       knowledgeBaseId: '',
       knowledgeDetails: {},
      popupcreateticket:false,
      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],
      searchQuery: '',
      
    }
  },
  computed: {
     
  },
  methods: {
    checkValue(object =null ,mainKey='' ,subKey =''){
         if(object != null && mainKey !='' ){
             if(_.has(object ,mainKey)){
 
                 if(subKey !=''){
                     if( _.has(object[mainKey] ,subKey )){
                         return object[mainKey][subKey];
 
                     }else{
                         return '';
 
                     }
 
                 }else{
                     return object[mainKey];
 
                 }
 
             }else{
                 return '';
             }
 
         }else{
             return '';
         }
 
    

    },
     getDetails() {
      let payload = {
        documentId: this.knowledgeBaseId,
      };
      let path ="/document/details";
      
      this.$store.dispatch("commonAction", { "data": payload,"path":path}).then((res) => {
      
          this.knowledgeDetails = res;
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    download_file(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }

      let postdata = { keyName: value.url };

      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        
          window.open(response.data.result.data, "_blank");
       
      });
    },
  }, 
  mounted() {
     if (
      this.$route.params.documentId != undefined &&
      this.$route.params.documentId != null
    ) {
      this.knowledgeBaseId = this.$route.params.documentId;
      this.getDetails();
    }
  }
}
</script>

<style lang="scss">

</style>
